module.exports = __webpack_public_path__ + "static/city2-02b18a7f8b01615f26261e5e4dc4d029.jpg";